import { auto } from './basler-components.es810.js';
import { number } from './basler-components.es805.js';
import { px, percent, degrees, vw, vh } from './basler-components.es806.js';
import { testValueType } from './basler-components.es811.js';

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

export { dimensionValueTypes, findDimensionValueType };
